

export class PatientAmount {
    Amount: number;
    RemaningAmount: number = 0;
    constructor() {

    }
}